import { useTranslation } from 'react-i18next'

import { DateStepper } from '~/components/common/filters'
import { useJstMidnightTick } from '~/hooks/useJstMidnightTick'
import { startOfTodayJst } from '~/models/dateTime'

type Props = {
  /** `${labelKeyPrefix}.displayDate` / `.today` を参照する。 */
  labelKeyPrefix: string
  displayDate: Date
  onDateChange: (date: Date) => void
  onToday: () => void
}

/**
 * 開閉式フィルターの条件のカードに置く「表示日」の部品 (前日 / 日付 / 翌日 / 今日)。
 * ラベルは FilterGrid が出すので持たない。共通の `DateNav` はラベルを自前で出すため、
 * カードの格子には使わない。
 *
 * 同時同量は当日の実績を監視する画面なので未来日は選べない (`DateNav` と同じ上限・理由文。
 * issue #6361)。日跨ぎで上限を取り直すのも `DateNav` と同じ。
 */
export const DisplayDateControl = ({
  labelKeyPrefix,
  displayDate,
  onDateChange,
  onToday,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  useJstMidnightTick()

  return (
    <DateStepper
      dateAriaLabel={t(`${labelKeyPrefix}.displayDate`)}
      layout="inline"
      maxDate={startOfTodayJst()}
      maxDateDisabledReason={t('common:filter.nextDayDisabled')}
      onChange={onDateChange}
      onTodayClick={onToday}
      todayLabel={t(`${labelKeyPrefix}.today`)}
      value={displayDate}
    />
  )
}
